import { Tooltip as TooltipUI } from '@cycle-app/ui';
import styled from 'styled-components';

export const Tooltip = styled(TooltipUI)``;

export const IconContainer = styled.div`
  display: flex;
`;
